/**
 * @module Template-Footer
 */

import { NavLink } from "react-router-dom";
import { navUrl } from "../../../globals/common-functions";
import { route } from "../../../globals/constants";
import AvertImage from "../../../globals/elements/avertimg";
import './footer.scss';

/**
 * 
 * @returns Markup for the template footer
 */
const SectionFooter = () => {
    return (
        <footer className="footer-dark">
            <div className="container">
                {/* FOOTER BLOCKES START */}
                <div className="footer-top">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="widget widget_about">
                                <div className="logo-footer clearfix">
                                    <NavLink to={route.INITIAL}><AvertImage src="images/logos/logo100-white.png" alt="" /> </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-4 col-6">
                            <div className="widget widget_services ftr-list-center">
                                <h3 className="widget-title">Contact Information</h3>
                                <ul className="ftr-list">
                                    <li><i className="feather feather-phone-call" /><a href="tel:+256744666608">+(256) 744 666608</a></li>
                                    <li><i className="feather feather-mail" /><a href="mailto:info@theanathoth.com">info@theanathoth.com</a></li>
                                    <li><i className="feather feather-map-pin" />1 Kololo Hill Drive, K'la, UG.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-4 col-6">
                            <div className="widget widget_services ftr-list-center">
                                <h3 className="widget-title">Quick Links</h3>
                                <ul>
                                    <li><NavLink to={navUrl.pages(route.pages.FAQ)}>FAQ</NavLink></li>
                                    <li><NavLink to={navUrl.blogs(route.blogs.INITIAL)}>Blog</NavLink></li>
                                    <li><NavLink to={navUrl.pages(route.pages.CONTACT)}>Contact Us</NavLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                            <div className="widget ftr-list-center">
                                <h3 className="widget-title">Governance</h3>
                                <ul className="governance-links">
                                    <li><NavLink to={navUrl.pages(route.pages.PRIVACY_POLICY)}><i className="feather feather-shield"></i> Privacy Policy</NavLink></li>
                                    <li><NavLink to={navUrl.pages(route.pages.TERMS_OF_SERVICE)}><i className="feather feather-file-text"></i> Terms of Service</NavLink></li>
                                    <li><NavLink to={navUrl.pages(route.pages.COOKIE_POLICY)}><i className="feather feather-settings"></i> Cookie Policy</NavLink></li>
                                    {/* <li><NavLink to={navUrl.pages(route.pages.ACCEPTABLE_USE_POLICY)}><i className="feather feather-check-circle"></i> Acceptable Use</NavLink></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* FOOTER COPYRIGHT */}
            <div className="footer-bottom">
                <div className="footer-bottom-info">
                    <div className="footer-copy-right">
                        <span className="copyrights-text"><span className="site-text-primary">© 2011 - 2025</span> Anathoth Technologies Limited. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default SectionFooter;